import { Placeholder, PlaceholderLine, Segment } from 'semantic-ui-react';
import styled from '@emotion/styled';
import { Text } from '@britishcouncil/react-admin';

import { useGetExaminerQuery, useGetExaminerStatusQuery } from 'store';
import { useExaminerId } from './useExaminerId';
import { ExaminerStatusLabels } from 'components/examiner-statuses/ExaminerStatusLabels';

export const ExaminerProfileBox = () => {
  const examinerId = useExaminerId();
  const { data: examiner, isLoading: isExaminerLoading } = useGetExaminerQuery(examinerId);
  const { data: statusData, isLoading: isStatusLoading } = useGetExaminerStatusQuery(examinerId);

  return (
    <Segment color="yellow" textAlign="center">
      {isExaminerLoading || isStatusLoading ? (
        <ExaminerProfileBoxPlaceholder />
      ) : (
        <>
          <Text size="large">
            <strong>
              {examiner?.firstName} {examiner?.lastName}&nbsp;
              {examiner?.examinerNumber && `(${examiner.examinerNumber})`}
            </strong>
          </Text>
          <ExaminerStatusLabels template="label" examinerStatuses={statusData} />
        </>
      )}
    </Segment>
  );
};

const ExaminerProfileBoxPlaceholder = () => {
  return (
    <>
      <S.TitlePlaceholder>
        <PlaceholderLine />
      </S.TitlePlaceholder>
      <S.StatusPlaceholderBox>
        <StatusPlaceholder />
        <StatusPlaceholder />
        <StatusPlaceholder />
        <StatusPlaceholder />
        <StatusPlaceholder />
        <StatusPlaceholder />
      </S.StatusPlaceholderBox>
    </>
  );
};

const StatusPlaceholder = () => (
  <S.StatusPlaceholder>
    <PlaceholderLine />
  </S.StatusPlaceholder>
);

const S = {
  TitlePlaceholder: styled(Placeholder)`
    display: flex;
    justify-content: center;
    margin: 0 auto;
  `,
  StatusPlaceholderBox: styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-bottom: 2rem;
  `,
  StatusPlaceholder: styled(Placeholder)`
    display: flex;
    justify-content: center;
    width: 200px;
    margin-top: 2rem;
  `,
};
